var _rect, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIcnDisplaySm(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 26 26",
    height: 10,
    width: 10,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    fill: "#272727",
    height: 26,
    rx: 13,
    width: 26
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-76.523 -12.007)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 89.023,
    cy: 22.507,
    fill: "#fff",
    r: 2.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.978 32.775a.931.931 0 001.231 0c.223-.2 5.455-4.859 5.455-9.7a6.07 6.07 0 10-12.14 0c-.001 4.84 5.231 9.504 5.454 9.7zm.615-11.282a1.587 1.587 0 11-1.574 1.587 1.58 1.58 0 011.574-1.587z",
    fill: "#ee1848"
  }))));
}

export default SvgIcnDisplaySm;